import Cleave from "cleave.js/react";
// @ts-ignore
import { tw } from "@careinfo/tailwind";

const NumberField = ({
  placeholder,
  value,
  onChange,
  onBlur,
  errors,
  label,
  disabled,
}: any) => {
  return (
    <div className={tw`w-full my-2 text-left`}>
      <label>{label}</label>

      <Cleave
        type="text"
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        onBlur={onBlur}
        onChange={onChange}
        disabled={disabled}
        options={{
          numeral: true,
          numeralDecimalMark: ".",
          numeralDecimalScale: 0,
          numeralPositiveOnly: true,
          delimiter: "",
        }}
      />

      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors.message}</p>
      )}
    </div>
  );
};

export default NumberField;
